// npm install video.js videojs-contrib-hls
// 用 rtsp rtsp://admin:Camel168@192.168.0.31:554/11 播放视频

import { Component, OnInit, Input, ChangeDetectionStrategy } from '@angular/core';
import { OnDestroy, ElementRef, ViewChild } from '@angular/core';
import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser';
//import videojs from 'video.js';

//declare const videimport videojs from 'video.js';
/*     <video #videoPlayer class="video-js vjs-default-skin" controls preload="auto" width="640" height="264">
      <source src="url" type="application/x-mpegURL">
    </video>
*/
@Component({
  standalone: true,
  selector: 'app-rtsp',
  changeDetection: ChangeDetectionStrategy.Eager,
  template: `
  <video #videoPlayer class="video-js" controls muted playsinline preload="none"></video>
  `,//<iframe [src]="url" width="100%" height="100%"></iframe>
  //styleUrls: ['./rtsp.component.css']
})
export class RtspComponent implements OnInit, OnDestroy {
  @ViewChild('videoPlayer', { static: true }) videoPlayer!: ElementRef;
  //@Input() url: SafeResourceUrl = this.sanitizer.bypassSecurityTrustResourceUrl('rtsp://admin:Camel168@192.168.0.31:554/11');
  // See options: https://videojs.com/guides/options
  @Input() options!: {
      //fluid: boolean,
      //aspectRatio: string,
      autoplay: boolean,
      controls: boolean,
      sources: {
          src: string,
          type: string,
      }[],
  };
  player: any;

  constructor(private sanitizer: DomSanitizer) {}
  ngOnInit() {
    //this.player = videojs(this.videoPlayer.nativeElement,this.options);
  }
  ngOnDestroy() {
    if (this.player) {
      this.player.dispose();
    }
  }

}

